/** Haber içerik tipleri — DB `news.is_type` */
export const NEWS_TYPE = {
  ARTICLE: 0,
  GALLERY: 1,
  VIDEO: 2,
  SHORT: 3,
} as const;

export type NewsTypeValue = (typeof NEWS_TYPE)[keyof typeof NEWS_TYPE];

export function isShortNews(isType?: number | null): boolean {
  return Number(isType) === NEWS_TYPE.SHORT;
}

export function isShortsPlayableSource(news: {
  youtube?: string | null;
  video?: string | null;
  dailymotion?: string | null;
  vimeo?: string | null;
  x?: string | null;
  facebook?: string | null;
}): boolean {
  return [
    news.youtube,
    news.video,
    news.dailymotion,
    news.vimeo,
    news.x,
    news.facebook,
  ].some((value) => typeof value === 'string' && value.trim().length > 0);
}

export function isClassicVideoNews(isType?: number | null): boolean {
  return Number(isType) === NEWS_TYPE.VIDEO;
}

export function hasVideoSource(news: {
  video?: string | null;
  youtube?: string | null;
  dailymotion?: string | null;
  vimeo?: string | null;
  x?: string | null;
  facebook?: string | null;
  playerType?: number | null;
}): boolean {
  return !!(
    news.video?.trim() ||
    news.youtube?.trim() ||
    news.dailymotion?.trim() ||
    news.vimeo?.trim() ||
    news.x?.trim() ||
    news.facebook?.trim()
  ) && !!news.playerType;
}

export interface ShortFeedItem {
  id: number;
  source?: 'news' | 'youtube';
  title: string;
  title_short?: string | null;
  titleSub?: string | null;
  description?: string | null;
  slug: string;
  image: string | null;
  createdAt: string;
  viewCount?: number;
  shareCount?: number;
  likeCount?: number;
  commentCount?: number;
  comments?: number | null;
  video?: string | null;
  youtube?: string | null;
  dailymotion?: string | null;
  vimeo?: string | null;
  x?: string | null;
  facebook?: string | null;
  playerType?: number | null;
  isType?: number;
  category: {
    id: number;
    title: string;
    slug: string;
    color?: string | null;
  } | null;
  editor?: {
    id: number;
    name: string;
    surname?: string | null;
    username?: string | null;
    avatar?: string | null;
    image?: string | null;
  } | null;
  youtubeChannel?: {
    name: string | null;
    avatarUrl: string | null;
    url: string | null;
  } | null;
}

export interface ShortsFeedResponse {
  news: ShortFeedItem[];
  total: number;
  page: number;
  totalPages: number;
  hasMore: boolean;
}
